import type { ProformaReqTypeConfig } from '@atlassian/jira-proforma-request-type-config/src/types.tsx';
import type { ReqTypeContext, SelectedForm } from '../types.tsx';

export const ADD_PROFORMA_FORM_OPTIMISTICALLY = 'ADD_PROFORMA_FORM_OPTIMISTICALLY' as const;
export const DISCARD_PROFORMA_CHANGES = 'DISCARD_PROFORMA_CHANGES';
export const FETCH_PROFORMA_REQ_TYPE_CONFIG_SUCCESS =
	'FETCH_PROFORMA_REQ_TYPE_CONFIG_SUCCESS' as const;
export const MARK_PROFORMA_REQ_TYPE_FORM_FOR_REMOVAL =
	'MARK_PROFORMA_REQ_TYPE_FORM_FOR_REMOVAL' as const;
export const REMOVE_PROFORMA_REQ_TYPE_FORM_SUCCESS = 'REMOVE_PROFORMA_REQ_TYPE_FORM_SUCCESS';
export const SAVE_CHANGES_START = 'SAVE_CHANGES_START';
export const SAVE_CHANGES_SUCCESS = 'SAVE_CHANGES_SUCCESS';
export const SET_REQ_TYPE_CONTEXT = 'SET_REQ_TYPE_CONTEXT';
export const SYNC_PROFORMA_FORM_START = 'SYNC_PROFORMA_FORM_START';
export const SYNC_PROFORMA_FORM_SUCCESS = 'SYNC_PROFORMA_FORM_SUCCESS';

export type AddProformaFormOptimisticallyPayload = SelectedForm;

export type AddProformaFormOptimisticallyAction = {
	type: typeof ADD_PROFORMA_FORM_OPTIMISTICALLY;
	payload: AddProformaFormOptimisticallyPayload;
};

export type DiscardProformaChangesAction = {
	type: typeof DISCARD_PROFORMA_CHANGES;
};

export type FetchProformaReqTypeConfigSuccessPayload = ProformaReqTypeConfig;

export type FetchProformaReqTypeConfigSuccessAction = {
	type: typeof FETCH_PROFORMA_REQ_TYPE_CONFIG_SUCCESS;
	payload: FetchProformaReqTypeConfigSuccessPayload;
};

export type MarkProformaReqTypeFormForRemovalPayload = number;

export type MarkProformaReqTypeFormForRemovalAction = {
	type: typeof MARK_PROFORMA_REQ_TYPE_FORM_FOR_REMOVAL;
	payload: MarkProformaReqTypeFormForRemovalPayload;
};

export type RemoveProformaReqTypeFormSuccessAction = {
	type: typeof REMOVE_PROFORMA_REQ_TYPE_FORM_SUCCESS;
};

export type SaveChangesStartAction = {
	type: typeof SAVE_CHANGES_START;
};

export type SaveChangesSuccessAction = {
	type: typeof SAVE_CHANGES_SUCCESS;
};

export type SetReqTypeContextPayload = ReqTypeContext;

export type SetReqTypeContextAction = {
	type: typeof SET_REQ_TYPE_CONTEXT;
	payload: SetReqTypeContextPayload;
};

export type SyncProformaFormStartAction = {
	type: typeof SYNC_PROFORMA_FORM_START;
};

export type SyncProformaFormSuccessAction = {
	type: typeof SYNC_PROFORMA_FORM_SUCCESS;
};

export type Action =
	| AddProformaFormOptimisticallyAction
	| DiscardProformaChangesAction
	| FetchProformaReqTypeConfigSuccessAction
	| MarkProformaReqTypeFormForRemovalAction
	| RemoveProformaReqTypeFormSuccessAction
	| SaveChangesStartAction
	| SaveChangesSuccessAction
	| SetReqTypeContextAction
	| SyncProformaFormStartAction
	| SyncProformaFormSuccessAction;
